import type { BadgeProps } from "@salestrak/ui";

// Status color names → Badge soft variants. "destructive" maps to the soft
// "error" treatment (the "destructive" variant is a solid fill); anything
// without a semantic tone (muted, unknown strings) reads as secondary.
export function statusBadgeVariant(
  color: "success" | "warning" | "info" | "destructive" | "muted" | string,
): BadgeProps["variant"] {
  switch (color) {
    case "success":
      return "success";
    case "warning":
      return "warning";
    case "info":
      return "info";
    case "destructive":
      return "error";
    default:
      return "secondary";
  }
}
